import styled from 'styled-components';
import colors from '../../../../../utils/colors';
import {media} from '../../../../../utils/uiSizes';

const StyledInput = styled.input`
	font-family: FyranSans-Book, sans-serif;
	font-size: 1.125rem;
	letter-spacing: 0.014em;

  padding: 0.75rem 0.625rem;
	background: ${colors.WHITE};
	border: 1px solid ${colors.GRAY_LIGHT};
	border-radius: 0.3125rem;
	color: ${colors.GRAY_DARK};
  box-sizing: border-box;
  width: 100%;


  ${props => props.inline && `
    display: inline-block;
  `}

  &:-webkit-autofill {
    box-shadow: 0 0 0 5em white inset;
  }

  &::-webkit-input-placeholder {
    color: ${colors.GRAY};
    height: inherit !important;
    font-size: inherit !important;
    line-height: inherit !important;
    overflow: visible;
    margin: 0;
  }

  &:focus {
    border-color: ${colors.GRAY};
  }

  &:disabled {
    color: ${colors.GRAY_LIGHT};
    &::-webkit-input-placeholder {
      color: inherit;
    }
  }

  &[readonly] {
    border: 0;
    color: ${colors.GRAY};
    padding-left: 0;
    padding-right: 0;
    background: none;
    display: block;
    word-break: break-word;
    ${media.tablet`
      word-break: inherit;
    `}
  }

  .error & {
    border: 2px solid ${colors.BRAND_RED_LIGHTEST};
    margin: -1px 0;
  }
`;

export default StyledInput;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledInput.js